import React, { useEffect, useState } from 'react';
import { NextSeo } from 'next-seo';

import Header from '../../components/enfusion/Header';
import Footer from '../../components/enfusion/Footer';
import { useAppContext } from '../../util/context';

import { flatListToHierarchical } from '../../util/wordpress';

import Posts from './posts';
import Sidebar from './sidebar';
import NewsHeader from './header';

const NewsLayout = ({ pageProps = {} }) => {
    const { news, nextSeoProps, options } = pageProps;

    const context = useAppContext();
    context.toggleDarkMode(false);
    context.toggleHeaderTheme('bg-white');

    // Filter post function based on category selection
    const [filterCategories, setFilterCategories] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const resetFilterCategories = () => setFilterCategories([]);

    function filterPosts(slug) {
        const index = filterCategories.indexOf(slug);

        if (index === -1) {
            setFilterCategories([...filterCategories, slug]);
        } else {
            const copy = [...filterCategories];
            copy.splice(index, 1);

            setFilterCategories(copy);
        }
    }
    return (
        <>
            <NextSeo {...nextSeoProps} />
            <Header {...pageProps} />

            <main className="text-purple-midnight">
                <NewsHeader
                    title="Enfusion in the news"
                    link={options?.inTheNewsMedia?.irLink}
                />
                <div className="container pb-24">
                    <div className="relative justify-between lg:flex">
                        <div className="w-full lg:max-w-[224px]">
                            <Sidebar
                                filterPosts={filterPosts}
                                categories={news?.newsTypes?.nodes}
                                regions={news?.newsRegions?.nodes}
                                years={news?.newsYears?.nodes}
                                setSearchQuery={setSearchQuery}
                                resetFilterCategories={resetFilterCategories}
                                filterCategories={filterCategories}
                            />
                        </div>
                        <div className="w-full lg:max-w-[830px] pl-0 xl:pl-0 lg:pl-6">
                            <Posts
                                filterCategories={filterCategories}
                                news={news?.contentNodes?.nodes}
                                searchQuery={searchQuery}
                                setSearchQuery={setSearchQuery}
                            />
                        </div>
                    </div>
                    {options?.inTheNewsMedia?.enable && (
                        <div className="pt-16 mt-16 text-white border-t lg:pt-24 border-purple-midnight border-opacity-20 lg:mt-24">
                            <div className="px-10 py-10 text-white bg-cover lg:flex-row lg:py-14 lg:px-24 bg-gradient-12">
                                {options?.inTheNewsMedia?.heading && (
                                    <p
                                        className="mb-4 font-medium label md:mb-6"
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                options?.inTheNewsMedia?.heading
                                        }}
                                    />
                                )}
                                {options?.inTheNewsMedia?.subHeading && (
                                    <h4
                                        className="mb-4 md:h3 h4 md:mb-8"
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                options?.inTheNewsMedia
                                                    ?.subHeading
                                        }}
                                    />
                                )}
                                {options?.inTheNewsMedia?.name && (
                                    <h6
                                        className="mb-3 md:h6 lead opacity-70"
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                options?.inTheNewsMedia?.name
                                        }}
                                    />
                                )}
                                {options?.inTheNewsMedia?.email && (
                                    <a
                                        href={`mailto:${options?.inTheNewsMedia?.email}`}
                                        className="inline-block mb-3 text-white md:h6 lead opacity-70"
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                options?.inTheNewsMedia?.email
                                        }}
                                    />
                                )}
                                {options?.inTheNewsMedia?.phone && (
                                    <>
                                        <br />
                                        <a
                                            href={`tel:${options?.inTheNewsMedia?.phone}`}
                                            className="inline-block text-white md:h6 lead opacity-70"
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                    options?.inTheNewsMedia
                                                        ?.phone
                                            }}
                                        />
                                    </>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </main>

            <Footer {...pageProps} />
        </>
    );
};

export default NewsLayout;
